import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { $GET } from "../../../../api";
import { addServices } from "../../../../store/slices/services.slice";
import Router from "../../../../const/router";
import Table from "../../Table";
import Aside from "../../Aside";
import AdminServicesForm from "../../../forms/services/admin-services-form";
import AdminServicesUploadForm from "../../../forms/services/admin-services-upload-form";

const AdminServices = () => {
  const { headerData, data } = useSelector((state) => state.services);
  const dispatch = useDispatch();

  useEffect(() => {
    const fillServices = async () => {
      try {
        const { data } = await $GET(Router.SERVICES);
        dispatch(addServices(data));
      } catch (err) {
        throw new Error(err.message);
      }
    };
    fillServices();
  }, []);

  return (
    <section className="admin-services admin-section">
      <Aside />
      <div className="section-wrapper">
        <div className="row">
          <div className="admin-section-add">
            <AdminServicesForm />
          </div>
          <div className="admin-section-upload">
            <AdminServicesUploadForm />
          </div>
        </div>
        <Table
          headerData={headerData}
          contentData={data}
          route={Router.SERVICES}
        />
      </div>
    </section>
  );
};

export default AdminServices;
